export default __webpack_public_path__ + "static/media/agent.65daab85.svg";